class TaxationController {
  /* @ngInject */
  constructor(StorageService) {
    this.name = 'taxation';
    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
  }
}

export default TaxationController;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/taxation.controller.js
 **/